import PropTypes from 'prop-types';
import React from 'react';
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import accounting from 'accounting';
import { getCurrencySymbol } from 'components/modules/master/formatters';

export default class AccessorialRatesFlatFeeEditor extends React.Component {
  handleFlatFeeChange() {
    return (e) => {
      const rate = Number(e.target.value);
      this.props.onChange('rate', rate);
      const description = accounting.formatMoney(
        rate,
        getCurrencySymbol(DEFAULT_CURRENCY),
      );
      this.props.onChange('description', description);
    };
  }

  validateValue(rate) {
    if (rate > 0) {
      return '';
    }
    return 'error';
  }

  render() {
    const accessorialRate = this.props.accessorialRate || {};
    return (
      <Grid fluid>
        <Row className="show-grid">
          <Col xs={4}>
            <FormGroup>
              <ControlLabel>{`${accessorialRate.name} (${getCurrencySymbol(
                DEFAULT_CURRENCY,
              )})`}</ControlLabel>
              <FormControl
                type="number"
                defaultValue={accessorialRate.rate}
                onChange={this.handleFlatFeeChange()}
                bsStyle={this.validateValue(accessorialRate.rate)}
              />
            </FormGroup>
          </Col>
        </Row>
      </Grid>
    );
  }
}

AccessorialRatesFlatFeeEditor.propTypes = {
  accessorialRate: PropTypes.object,
  onChange: PropTypes.func,
};
